/**
 * AR Email Intelligence Demo — Scene 6 payoff copy + metrics (E4 / GEN-2266).
 *
 * THROWAWAY DEMO CODE. Illustrative numbers for the closing payoff line. These
 * are clearly-labelled DEMO figures, not measured product metrics — they live in
 * a const so the surface renders them from one place. Delete with
 * frontend/src/demo/ar/email-intel.
 */

/** One headline payoff stat for the closing metric strip. */
export interface IntelPayoffMetric {
  /** Big value, e.g. "80%". */
  value: string;
  /** Short caption under the value. */
  label: string;
}

/** Illustrative demo metrics for the Scene-6 close. NOT product measurements. */
export const INTEL_PAYOFF_METRICS: readonly IntelPayoffMetric[] = [
  { value: '80%', label: 'of drafts accepted as-is' },
  { value: '~6 hrs', label: 'saved per collector each week' },
  { value: '1 reply', label: 'cleared the dispute — first try' },
] as const;

/** Send-animation duration (ms) when motion is allowed. */
export const INTEL_SEND_ANIMATION_MS = 1400;
